import { useRouter } from "next/router";

type ProductIntent = "aperture" | "agents" | "apps";

/**
 * Extracts and validates the ?product query param.
 * Returns the product intent when present and valid, otherwise undefined.
 */
export function useProduct(): ProductIntent | undefined {
  const router = useRouter();
  const rawProduct = Array.isArray(router.query.product)
    ? router.query.product[0]
    : router.query.product;
  if (
    rawProduct === "aperture" ||
    rawProduct === "agents" ||
    rawProduct === "apps"
  ) {
    return rawProduct;
  }
  return undefined;
}

/**
 * Returns the param string to append to OAuth URLs (e.g., "?product=aperture" or "").
 */
export function useProductParam(): string {
  const product = useProduct();
  return product ? `?product=${product}` : "";
}
